<template>
  <div class="currency-input clearfix">
    <div v-if="!hide" class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="input-group">
          <input class="form-control" type="text"
            :id="options.name"
            :value="value"
            :name="options.name"
            @input="validate($event.target.value)"/>
          <div class="input-group-append">
            <span class="input-group-text">
              <template v-if="isRegex">
                {{ value | toDollarAmount }}
              </template>
              <template v-else>
                Invalid Dollar Amount
              </template>
            </span>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          amended: false,
          required: false
        }
      }
    },
    onChange: {
      type: Function,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false,
      isLength: false,
      isRegex: false,
      regex: /^[0-9]*(\.[0-9]{1,2}){0,1}$/,
      maxValue: false,
      minValue: false,
      reportType: false,
      lots: false,
      numberOfStop: 2,
      watcher: false,
      hide: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (this.maxValue && this.value > this.maxValue && this.isRegex) {
        return 'Amount cannot be more than $' + this.maxValue
      } else if (this.minValue || this.options.minValue === 0 && this.value <= this.minValue && this.isRegex) {
        return 'Amount must be more than $' + this.minValue
      } else {
        return 'The amount entered is not a valid dollar amount'
      }
    }
  },
  mounted () {
    if (this.options.hidden) this.hide = true
    if (this.options.maxValue) {
      this.maxValue = parseFloat(this.options.maxValue)
    }
    if (this.options.minValue || this.options.minValue === 0) {
      this.minValue = parseFloat(this.options.minValue)
    }
    this.validate()
  },
  methods: {
    validate (val = this.value) {
      if (val === null) {
        val = '0'
      }
      this.$emit('input', val)
      this.onChange()
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length !== 0
        if (this.isValid) {
          this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
        }
        if (this.maxValue && this.isValid) {
          this.isValid = parseFloat(val) <= this.maxValue
        }
        if (this.minValue || this.options.minValue === 0 && this.isValid) {
          this.isValid = this.isValid && parseFloat(val) > this.minValue
        }
      } else if (this.options.required) {
        this.isDirty = true
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    async updateReportCost () {
      if (this.reportType && this.lots) {
        let options = {
          lots: this.lots,
          reportType: this.reportType
        }
        let instance = new Api()
        let reportCost = await instance.getReportCost(options)
        this.validate(reportCost)
      }
    },
    runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        if (val || val === false) {
          switch (name) {
            case 'quoteNotApplicable':
              this.hide = val
              break
            case 'lots':
              this.lots = val
              let reportValue = this.$parent.$refs.fields.find(el => el.options.name === 'reportType')
              if (reportValue.value) {
                this.reportType = reportValue.value
              }
              this.updateReportCost()
              break
            case 'reportType':
              if (this.options.amended && this.numberOfStop > 0) {
                // Since Quote price can be custom, I have to restrict the execution of watcher twice while editing the quote
                // (why twice, because there are two fields in watcher and that is why it is executing twice)
                this.numberOfStop = this.numberOfStop - 1
              } else {
                this.watcher = true
              }
              if (this.watcher) {
                let lotsValue = this.$parent.$refs.fields.find(el => el.options.label === 'Lots')
                if (lotsValue.value) {
                  this.lots = lotsValue.value
                }
                this.reportType = val
                this.updateReportCost()
              }
              break
          }
        } else {
          this.validate('')
          this.isDirty = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CurrencyInput.vue